import PropTypes from 'prop-types';
import React from 'react';
import './dashboard.scss';

const OnboardingContent = ({ title, content, currentStep, maxStep }) => {
  return (
    <div className="onboarding-tooltip-firstStep">
      <div className="onboarding-tooltip-header">
        <h3>{title}</h3>
        <span>{`(${currentStep} of ${maxStep})`}</span>
      </div>
      <p className="onboarding-tooltip-content">{content}</p>
    </div>
  );
};

export default OnboardingContent;

OnboardingContent.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  currentStep: PropTypes.number.isRequired,
  maxStep: PropTypes.number.isRequired
};
